export default __webpack_public_path__ + "static/media/provider.51b36e64.svg";